import React, { Fragment } from "react";
import PrimaryButton from "components/Buttons/PrimaryButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import DangerButton from "components/Buttons/DangerButton";
import { Dialog } from "@headlessui/react";
import ModalRoot from "./ModalRoot";

export default function CustomModal(props) {
    const getButtons = (modal) => {
        if (modal.buttons instanceof Function && modal.didProvideButtons) {
            return modal.buttons(modal);
        }

        if (modal.variant === "success") {
            return (
                <PrimaryButton
                    onClick={modal.onConfirm}
                    disabled={modal.disabled}
                >
                    Okay
                </PrimaryButton>
            );
        } else if (modal.variant === "warning") {
            return (
                <Fragment>
                    <DangerButton
                        onClick={modal.onConfirm}
                        disabled={modal.disabled}
                    >
                        Okay
                    </DangerButton>
                    <SecondaryButton
                        onClick={modal.onCancel}
                        disabled={modal.disabled}
                    >
                        Cancel
                    </SecondaryButton>
                </Fragment>
            );
        } else if (modal.variant === "error") {
            return (
                <DangerButton
                    onClick={modal.onConfirm}
                    disabled={modal.disabled}
                >
                    Okay
                </DangerButton>
            );
        } else {
            return (
                <Fragment>
                    <PrimaryButton
                        type="button"
                        onClick={modal.onConfirm}
                        disabled={modal.disabled}
                    >
                        Okay
                    </PrimaryButton>
                    <SecondaryButton
                        onClick={modal.onCancel}
                        disabled={modal.disabled}
                    >
                        Cancel
                    </SecondaryButton>
                </Fragment>
            );
        }
    };
    return (
        <ModalRoot>
            {(modal) => (
                <Fragment>
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                            <Dialog.Title
                                as="h3"
                                className="text-lg font-medium leading-6 text-gray-900"
                            >
                                {modal.title}
                            </Dialog.Title>
                            <div className="mt-2 text-sm">{modal.children}</div>
                        </div>
                    </div>
                    <div className="space-x-5 space-x-reverse bg-gray-50 px-4 py-3 text-sm sm:flex sm:flex-row-reverse sm:px-6">
                        {getButtons(modal)}
                    </div>
                </Fragment>
            )}
        </ModalRoot>
    );
}
